import React, { Component } from 'react';
import { Container, Form, Row} from 'react-bootstrap';
import styled, { ThemeProvider } from 'styled-components';
import theme from '../../../../Config/Theme';

const Div = styled.div`
    background-color: white;
    color: black;
`

class Communication extends Component{

    render() {
        return (
            <ThemeProvider theme={theme}>
                <Div>
                    <Container>
                        <Form className="p-3">
                            
                            <div className="form-section">
                                <h4>Employee Communication</h4>
                                <hr />
                                <p className="font-italic font-weight-bold">
                                On a scale from 1 to 5 (1-Very Uncomfortable and
                                5-Very Comfortable...)
                                </p>

                                <Form.Group
                                as={Row}
                                name="formCommIdeas"
                                controlId="formCommIdeas"
                                onChange={this.props.handleChangeAsInt}
                                >
                                <Form.Label column sm={5}>
                                    10. How comfortable are you communicating ideas, sharing comments, or talking about concerns with the leadership team?
                                </Form.Label>
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="1"
                                    value="1"
                                    name="formCommIdeas"
                                    id="formCommIdeas-1"
                                    defaultChecked={this.props.formCommIdeas === 1}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="2"
                                    value="2"
                                    name="formCommIdeas"
                                    id="formCommIdeas-2"
                                    defaultChecked={this.props.formCommIdeas === 2}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="3"
                                    value="3"
                                    name="formCommIdeas"
                                    id="formCommIdeas-3"
                                    defaultChecked={this.props.formCommIdeas === 3}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="4"
                                    value="4"
                                    name="formCommIdeas"
                                    id="formCommIdeas-4"
                                    defaultChecked={this.props.formCommIdeas === 4}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="5"
                                    value="5"
                                    name="formCommIdeas"
                                    id="formCommIdeas-5"
                                    defaultChecked={this.props.formCommIdeas === 5}
                                />
                                </Form.Group>

                                
                                <p className="font-italic font-weight-bold">
                                On a scale from 1 to 5 (1-Strongly Disagree and
                                5-Strongly Agree...)
                                </p>

                                <Form.Group
                                as={Row}
                                name="formCommLevels"
                                controlId="formCommLevels"
                                onChange={this.props.handleChangeAsInt}
                                >
                                <Form.Label column sm={5}>
                                    11. There is a good level of communication at all levels of the organization?
                                </Form.Label>
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="1"
                                    value="1"
                                    name="formCommLevels"
                                    id="formCommLevels-1"
                                    defaultChecked={this.props.formCommLevels === 1}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="2"
                                    value="2"
                                    name="formCommLevels"
                                    id="formCommLevels-2"
                                    defaultChecked={this.props.formCommLevels === 2}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="3"
                                    value="3"
                                    name="formCommLevels"
                                    id="formCommLevels-3"
                                    defaultChecked={this.props.formCommLevels === 3}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="4"
                                    value="4"
                                    name="formCommLevels"
                                    id="formCommLevels-4"
                                    defaultChecked={this.props.formCommLevels === 4}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="5"
                                    value="5"
                                    name="formCommLevels"
                                    id="formCommLevels-5"
                                    defaultChecked={this.props.formCommLevels === 5}
                                />
                                </Form.Group>

                                
                            </div>
                        </Form>
                    </Container>
                </Div>
            </ThemeProvider>
        )
    }
}

export default Communication;